module.exports = __webpack_public_path__ + "static/media/ok.e5758123.svg";